import { render, staticRenderFns } from "./sdDetail.vue?vue&type=template&id=d94d9e90&"
import script from "./sdDetail.vue?vue&type=script&lang=js&"
export * from "./sdDetail.vue?vue&type=script&lang=js&"
import style0 from "./sdDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports